import client from "./_client";

const endpointV1 = `/v1/votes`;

export const getUserVote = (entityId) =>
  client.get(endpointV1 + `/user?entityId=${entityId}`);

export const addUserVote = (data) => client.post(endpointV1, data);
